import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Notice } from '../page/Notice';
import type { SupplierPick } from './api';
import { useWhere } from './DuplicateNotice';

/**
 * Board 1.7: after the first «Crea» the server found similar names (409) and created nothing. A
 * warning, not a stop: «È un altro: crea» in the window's foot confirms.
 */
export function SimilarNotice({
  similar,
  onUse,
}: {
  readonly similar: readonly SupplierPick[];
  readonly onUse: (pick: SupplierPick) => void;
}) {
  const { t } = useTranslation('suppliers');
  const where = useWhere();
  return (
    <div role="alert">
      <Notice
        tone="info"
        icon={Info}
        title={t('picker.similar.title')}
        actions={similar.map((pick) => (
          <Button
            key={pick.id}
            type="button"
            variant="outline"
            className="min-h-11"
            onClick={() => onUse(pick)}
          >
            {t('picker.similar.use', { name: pick.name })}
          </Button>
        ))}
      >
        <ul className="flex flex-col gap-0.5">
          {similar.map((pick) => (
            <li key={pick.id}>
              «{pick.name}», {where(pick)}
              {pick.vat ? '' : `, ${t('picker.similar.noVat')}`}
            </li>
          ))}
        </ul>
        <span>{t('picker.similar.text')}</span>
      </Notice>
    </div>
  );
}
